import DropdownTable from './dropdownTable';

export default DropdownTable;
